module.exports = __webpack_public_path__ + "department-green.png?284f54fcd38c44eb06ec5fee5a2f0499";


//////////////////
// WEBPACK FOOTER
// ./images/department-green.png
// module id = 166
// module chunks = 0